import type { CSSProperties } from 'react'

/* Sets the delay a reveal class (reveal-line, reveal-fade, reveal-clip, reveal-rule) waits before it plays. */
export const revealDelay = (ms: number): CSSProperties => ({ '--reveal-delay': `${Math.round(ms)}ms` } as CSSProperties)
